import { useProfileStatus } from '@/hooks/useProfile'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/common/Button/Button'
import routes from '@/routes/routes'

const ProviderVerificationStatus = () => {
    const { data, isLoading } = useProfileStatus()
    const navigate = useNavigate()
    const status = data || { is_verified: false, is_profile_configured: false }
    return (
        <div className="provider-verification-status-page">
            <div className="provider-verification-status-container">
                <h1 className="provider-verification-status-title">Estado de Verificación</h1>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <div className="provider-verificationstatus_content">
                    <div>Verified: {status.is_verified ? 'Yes' : 'No'}</div>
                    <div>Profile Configured: {status.is_profile_configured ? 'Yes' : 'No'}</div>
                    {!status.is_profile_configured && (
                        <Button variant="primary" onClick={() => navigate(routes.providerConfigureProfile)} effect3d={false}>Configurar Perfil</Button>
                    )}
                </div>
            )}
            </div>
        </div>
    )
}

export default ProviderVerificationStatus


